import ApiKeyService from 'src/modules/apiKey/apiKeyService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'APIKEY_VIEW';

const apiKeyViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: apiKeyViewActions.FIND_STARTED,
      });

      const record = await ApiKeyService.find(id);

      dispatch({
        type: apiKeyViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: apiKeyViewActions.FIND_ERROR,
      });

      getHistory().push('/api-key');
    }
  },
};

export default apiKeyViewActions;
